import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"text-center",attrs:{"grid-list-md":""}},[_c('h1',[_vm._v("Velkommen til agree.ly")])])}
var staticRenderFns = []

export { render, staticRenderFns }